import { render } from "./document-categories-settings.vue?vue&type=template&id=149f4ff0"
import script from "./document-categories-settings.vue?vue&type=script&lang=js"
export * from "./document-categories-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__